import {PopulateDataHandler} from "../../../infrastructure/handlers/populate-data-handler";
import {CompetitionViewModel} from "../../../domain/common/competition/models/competition-view-model";
import {NewSearchWidgetSearchListModel} from "../models/new-search-widget.search-list.model";
import {CompetitorViewModel} from "../../../domain/common/competitor/models/competitor-view-model";
import {AthleteViewModel} from "../../../domain/common/athlete/athlete-view-model";
import type {NewSearchWidgetController} from "../new-search-widget.controller";
import type {NewSearchWidgetState} from "../models/new-search-widget.state";
import type {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";
import {NEW_SEARCH_WIDGET} from "../new-search-widget.consts";

export class NewSearchWidgetSearchPopulateDataHandler extends PopulateDataHandler {
  controller: NewSearchWidgetController;
  state: NewSearchWidgetState;

  static injectables = [...PopulateDataHandler.injectables];

  action(params) {
    const dataSource = params.dataSource;
    
    this.setCompetitionsResults(dataSource)
    this.setCompetitorsResults(dataSource)
    this.setAthletesResults(dataSource)
  }

  setCompetitionsResults(dataSource) {
    const competitions: Array<CompetitionViewModel> = dataSource?.competitions?.map(competition => new CompetitionViewModel(competition))

    if(this.state.competitionsSearchListModel === null) {
      this.state.competitionsSearchListModel = new NewSearchWidgetSearchListModel(NEW_SEARCH_WIDGET.LIST_ID.searchCompetitions, competitions, 'WEB_SEARCH_POPULAR_LEAGUES', this.controller.terms, 'WEB_SEARCH_NO_LEAGUES_EMPTY_STATE', this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.competitions);
    } else {
      this.state.competitionsSearchListModel.entities = competitions;
    }
  }

  setCompetitorsResults(dataSource) {
    const competitors: Array<CompetitorViewModel> = dataSource.competitors?.filter(competitor => competitor.type !== 4)?.map(competitor => new CompetitorViewModel(competitor))

    if(this.state.competitorsSearchListModel === null) {
      this.state.competitorsSearchListModel = new NewSearchWidgetSearchListModel(NEW_SEARCH_WIDGET.LIST_ID.searchCompetitors, competitors, 'WEB_SEARCH_POPULAR_TEAMS', this.controller.terms, 'WEB_SEARCH_NO_TEAMS_EMPTY_STATE', this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.competitors);
    } else {
      this.state.competitorsSearchListModel.entities = competitors;
    }
  }

  setAthletesResults(dataSource) {
    const tennisPlayers: Array<CompetitorViewModel> = dataSource.competitors?.filter(competitor => competitor.type === 4).map(competitor => new CompetitorViewModel(competitor));
    const athletes: Array<AthleteViewModel> = dataSource.athletes?.map(athlete => new AthleteViewModel(athlete));
    const allPlayers: Array<EntityViewModel> = [...athletes, ...tennisPlayers];
    const allPlayersSorted: Array<EntityViewModel> = allPlayers?.sort((a: EntityViewModel, b: EntityViewModel) => (b.popularityRank || 0) - (a.popularityRank || 0));

    if(this.state.athletesSearchListModel === null) {
      this.state.athletesSearchListModel = new NewSearchWidgetSearchListModel(NEW_SEARCH_WIDGET.LIST_ID.searchAthletes, allPlayersSorted, 'WEB_SEARCH_POPULAR_PLAYERS', this.controller.terms, 'WEB_SEARCH_NO_PLAYERS_EMPTY_STATE', this.controller.device.isSmallView, false, NEW_SEARCH_WIDGET.HIGHLIGHTED_LIST_INDEX.athletes);
    } else {
      this.state.athletesSearchListModel.entities = allPlayersSorted;
    }
  }
}
